import { BaseContainerModel } from '../base-container.model';
import { bl_ocr_company_hdr_RowClass } from '../../dbschema';

export class OCRCompanyContainerModel extends BaseContainerModel {
  bl_ocr_company_hdr: bl_ocr_company_hdr_RowClass = new bl_ocr_company_hdr_RowClass();
}
